import { Avatar, Flex, Icon, Text, useColorModeValue, Box, Link } from "@chakra-ui/react";
import { ClockIcon } from "components/Icons/Icons";
import { BellIcon } from "@chakra-ui/icons"; // Dodaj import ikony dzwonka
import { keyframes } from "@emotion/react"; // Dodaj import keyframes
import React from "react";
import { FaPaperclip, FaCarCrash, FaCar, FaScroll, FaBriefcase } from "react-icons/fa";
import { formatDistanceToNow, parseISO } from "date-fns";
import { pl } from 'date-fns/locale';
import { DateTime } from 'luxon';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const types = {
  1: {
    icon: FaPaperclip,
    withInfo: false,
    title: "Nałożono nowe S4"
  },
  2: {
    icon: FaCarCrash,
    withInfo: true,
    title: "Wycofano wóz"
  },
  3: {
    icon: FaCar,
    withInfo: true,
    title: "Przywrócono wóz"
  },
  4: {
    icon: FaScroll,
    withInfo: false,
    title: "Nowy artykuł zespołu prasowego"
  },
  5: {
    icon: FaBriefcase,
    withInfo: true,
    title: "Otworzono rekrutację do"
  },
};


function timeAgo(date) {
  return formatDistanceToNow(parseISO(date), { addSuffix: true, locale: pl });
}



export function ItemContent(props) {
  const navbarIcon = useColorModeValue("gray.500", "gray.200");
  const notificationColor = useColorModeValue("gray.700", "white");

  // Oblicz różnicę czasu
  const timeAgoText = timeAgo(props.time);

  return (
    <Box as={Link} display="flex" alignItems="center" href={props.link} target={props.link?.includes("http") ? "_blank" : ""}>
      {props.aSrc ? (
        <Avatar
          name={props.aName}
          src={props.aSrc}
          borderRadius="12px"
          me="16px"
        />
      ) : (
        <Box borderRadius="12px" bg={"red.600"} w="48px" h="48px" me="16px" justifyContent={"center"} alignItems={"center"} display={"flex"}>
          <Icon as={types[props.type].icon} color={navbarIcon} w="24px" h="24px" />
        </Box>
      )}
      <Flex flexDirection="column">
        <Flex mb="5px" color={notificationColor} gap={1} alignItems="center">
          <Text fontWeight="bold" fontSize="14px" as="span">
            {types[props.type].title}
          </Text>
          {types[props.type].withInfo && (
            <Text fontSize="14px" as="span">
              {props.info}
            </Text>
          )}
          {props.readed === 0 && (
            <Box w="10px" h="10px" bg="red.500" borderRadius="50%" animation={`${pulse} 1.5s infinite`} ml={"3px"} />
          )}
        </Flex>
        <Flex alignItems="center">
          <ClockIcon color={navbarIcon} w="13px" h="13px" me="3px" />
          <Text fontSize="xs" lineHeight="100%" color={navbarIcon}>
            {timeAgoText}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}